export const BUSINESS_ENTERPRISE_SUCCESS_BUY_NOW = {
  "en": "Buy now",
  "fr": "",
  "de": "",
  "es": "",
  "pt-br": "Buy now",
  "it": "Buy now",
  "ja": "Buy now",
  "ko": "Buy now",
  "nl": "Buy now",
  "pt-pt": "Buy now",
  "sv": "Buy now",
  "zh": "Buy now"
}